import { pipe } from 'fp-ts/lib/function';
import * as t from 'io-ts';
import qs from 'qs';

import * as O from 'fp-ts/Option';

import { useLocation } from 'react-router';
import { useAuth } from '../contexts/AuthContext';

const TeamIdQuery = t.type({
  team_id: t.string,
});

type TeamLike = Record<'id', string>;

const isUserTeam = (userTeams: O.Option<TeamLike[]>) => (teamId: string) => {
  return pipe(
    userTeams,
    O.map((teams) => teams.some((team) => team.id === teamId)),
    O.getOrElse(() => false),
  );
};

/**
 * Look on the querystring for a team ID and verify it's
 * a team ID the user can access.
 *
 */
export const useTeamIdParam = () => {
  const location = useLocation();
  const { user } = useAuth();

  const userTeams = O.fromNullable(user?.teams);

  const teamId = pipe(
    qs.parse(location.search, { ignoreQueryPrefix: true }),
    TeamIdQuery.decode,
    O.fromEither,
    O.map((q) => q.team_id),
    O.filter(isUserTeam(userTeams)),
  );

  return teamId;
};
